import { render } from "./PermissionsCard.vue?vue&type=template&id=6901671c&scoped=true"
import script from "./PermissionsCard.vue?vue&type=script&lang=js"
export * from "./PermissionsCard.vue?vue&type=script&lang=js"

import "./PermissionsCard.vue?vue&type=style&index=0&id=6901671c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6901671c"]])

export default __exports__